import React from "react"

export interface Theme {
    logo: string,
    primary_color: string,
    primary_color_hover: string,
    secondary_color: string,
    body_color: string,
    font_family: string,
    bottom_icons_color: string,
    btn_border_color: string,
    btn_background_color: string,
    btn_bg_gradient_value1: string,
    btn_bg_gradient_value2: string,
    btn_bg_gradient_value3: string,
    favicon: string;
    bg_img: string;
    body_text_color:string;
	light_gradient1:string;
	light_gradient2:string;
    text_heading: string;
	border_color: string;
    header_menu_background:string;
    text_heading_color:string;
    primary_button_color:string;
    secondary_button_color:string;
    primary_link_color:string;
}

export const liveGageTheme: Theme = {
    logo: "assets/img/logo.png",
    primary_color: "#0E5088",
    primary_color_hover: "#0E5088",
    secondary_color: "#FFFFFF",
    body_color: "#E6E6ED",
    font_family: "Lato, sans-serif",
    bottom_icons_color: "#2175BB",
    btn_border_color: "#0E5088",
    btn_background_color: "#333",
    btn_bg_gradient_value1: "#0E5088",
    btn_bg_gradient_value2: "#0E5088",
    btn_bg_gradient_value3: "#00afb1",
    favicon: "assets/img/lg-favicon.PNG",
    bg_img: "assets/img/bg_logo.svg",
    body_text_color:"#5A6B79",
	light_gradient1:"#FAFCFF",
	light_gradient2:"#F3F7FE",
    text_heading: "#385A77",
	border_color: "#FFFFFF",
    header_menu_background:"#F8FAFE",
    text_heading_color:"#FFFFFF",
    primary_button_color:"#0E5088",
    secondary_button_color:"#06A1C2",
    primary_link_color:"#2175BB"
}

export const liveGageDarkTheme: Theme = {
    logo: "assets/img/logo-dark.png",
    primary_color: "#FFFFFF",
    primary_color_hover: "#0E5088",
    secondary_color: "#FFFFFF",
    body_color: "#121216",
    font_family: "Lato, sans-serif",
    bottom_icons_color: "#2C9FFF",
    btn_border_color: "#0E5088",
    btn_background_color: "#333",
    btn_bg_gradient_value1: "#0FC9F1",
    btn_bg_gradient_value2: "#0D5CB9",
    btn_bg_gradient_value3: "#00afb1",
    favicon: "assets/img/lg-favicon.PNG",
    bg_img: "assets/img/bg_logo.svg",
    body_text_color:"#E9E9E9",
	light_gradient1:"#ffffff1a",
	light_gradient2:"#ffffff0d",
    text_heading: "#FFFFFF",
	border_color: "#D1D1D1",
    header_menu_background:"#2C353C",
    text_heading_color:"#385A77",
    primary_button_color:"#0E5088",
    secondary_button_color:"#06A1C2",
    primary_link_color:"#FFFFFF"
}

export const themeContext = React.createContext({});